export default __webpack_public_path__ + "static/media/header3.30bf5bf8.jpg";